import { render, staticRenderFns } from "./WordMDDocViewer.vue?vue&type=template&id=1b9e5ddb&scoped=true&"
import script from "./WordMDDocViewer.vue?vue&type=script&lang=js&"
export * from "./WordMDDocViewer.vue?vue&type=script&lang=js&"
import style0 from "./WordMDDocViewer.vue?vue&type=style&index=0&id=1b9e5ddb&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b9e5ddb",
  null
  
)

export default component.exports